var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.519 0.393494C26.8655 0.393494 0.393494 26.8655 0.393494 59.519C0.393494 92.1724 26.8655 118.644 59.519 118.644C92.1724 118.644 118.644 92.1724 118.644 59.519C118.644 26.8655 92.2002 0.393494 59.519 0.393494ZM59.519 18.1339C69.3039 18.1339 77.2594 26.0894 77.2594 35.8743C77.2594 45.687 69.3039 53.6147 59.519 53.6147C49.734 53.6147 41.7786 45.687 41.7786 35.8743C41.7786 26.0894 49.734 18.1339 59.519 18.1339ZM59.519 102.096C44.7168 102.096 31.6887 94.5286 24.0381 83.0528C24.1767 71.3274 47.7105 64.8411 59.519 64.8411C71.3274 64.8411 94.8335 71.3274 94.9998 83.0528C87.3493 94.5286 74.3489 102.096 59.519 102.096Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.0a0b71e0bb8929b6729572ada52d6a41.svg";
export { ForwardRef as ReactComponent };